/**
 * Shared PDP media loader: keep current image visible until the next one loads.
 * Usage:
 *   window.llLoadProductImage(imgEl, urlOrUrls)
 *   window.llLoadProductImage(imgEl, [webp, png, jpeg])
 */
(function (global) {
  var loadTokenByImg = new WeakMap();

  function ensureStyles() {
    if (document.getElementById("ll-media-loader-style")) return;
    var style = document.createElement("style");
    style.id = "ll-media-loader-style";
    style.textContent =
      ".ll-cuty-media-item.ll-image-zoom.is-loading .ll-image-zoom__img," +
      ".ll-cuty-media-item.is-loading img," +
      ".product__media.is-loading img{opacity:.55;transition:opacity .2s ease}" +
      ".ll-media-loader{position:absolute;inset:0;z-index:5;display:none;align-items:center;justify-content:center;pointer-events:none;background:rgba(255,255,255,.18)}" +
      ".ll-cuty-media-item.is-loading .ll-media-loader," +
      ".ll-cuty-media-item.ll-image-zoom.is-loading .ll-media-loader," +
      ".product__media.is-loading .ll-media-loader{display:flex}" +
      ".ll-media-loader__spinner{width:2.8rem;height:2.8rem;border:2px solid rgba(93,58,94,.2);border-top-color:hsl(299,20%,31%);border-radius:50%;animation:ll-media-spin .8s linear infinite}" +
      "@keyframes ll-media-spin{to{transform:rotate(360deg)}}" +
      "@media (prefers-reduced-motion:reduce){.ll-media-loader__spinner{animation:none}}";
    document.head.appendChild(style);
  }

  function resolveWrap(img) {
    if (!img) return null;
    return (
      img.closest(".ll-cuty-media-item.ll-image-zoom") ||
      img.closest(".ll-cuty-media-item") ||
      img.closest(".product__media") ||
      img.parentElement
    );
  }

  function ensureLoader(wrap) {
    if (!wrap) return null;
    ensureStyles();
    if (getComputedStyle(wrap).position === "static") {
      wrap.style.position = "relative";
    }
    var loader = wrap.querySelector("[data-ll-media-loader]");
    if (loader) return loader;
    loader = document.createElement("div");
    loader.className = "ll-media-loader";
    loader.setAttribute("data-ll-media-loader", "");
    loader.setAttribute("aria-hidden", "true");
    loader.innerHTML = '<div class="ll-media-loader__spinner"></div>';
    wrap.appendChild(loader);
    return loader;
  }

  function setLoading(wrap, isLoading) {
    if (!wrap) return;
    ensureLoader(wrap);
    wrap.classList.toggle("is-loading", Boolean(isLoading));
  }

  function normalizeCandidates(srcOrList) {
    if (!srcOrList) return [];
    if (Array.isArray(srcOrList)) return srcOrList.filter(Boolean);
    if (typeof srcOrList === "object") {
      return [srcOrList.webp, srcOrList.png, srcOrList.jpeg, srcOrList.jpg, srcOrList.legacy, srcOrList.src]
        .filter(Boolean);
    }
    return [srcOrList];
  }

  function sameAsset(currentSrc, nextSrc) {
    if (!currentSrc || !nextSrc) return false;
    try {
      var a = new URL(currentSrc, location.origin);
      var b = new URL(nextSrc, location.origin);
      return a.pathname === b.pathname;
    } catch (e) {
      return currentSrc === nextSrc || currentSrc.indexOf(nextSrc) !== -1;
    }
  }

  /**
   * @param {HTMLImageElement|string} imgOrSelector
   * @param {string|string[]|object} srcOrList
   * @param {{updateSrcset?: boolean}} [options]
   * @returns {Promise<boolean>}
   */
  function llLoadProductImage(imgOrSelector, srcOrList, options) {
    var img =
      typeof imgOrSelector === "string"
        ? document.querySelector(imgOrSelector)
        : imgOrSelector;
    if (!img) return Promise.resolve(false);

    var opts = options || {};
    var candidates = normalizeCandidates(srcOrList);
    if (!candidates.length) return Promise.resolve(false);

    if (sameAsset(img.currentSrc || img.src, candidates[0]) && candidates.length === 1) {
      return Promise.resolve(true);
    }

    var wrap = resolveWrap(img);
    var token = (loadTokenByImg.get(img) || 0) + 1;
    loadTokenByImg.set(img, token);
    setLoading(wrap, true);

    return new Promise(function (resolve) {
      var index = 0;

      function finish(ok, src) {
        if (loadTokenByImg.get(img) !== token) {
          resolve(false);
          return;
        }
        if (ok && src) {
          img.src = src;
          if (opts.updateSrcset !== false) {
            img.removeAttribute("srcset");
            if (opts.setSrcset) img.srcset = src;
          }
          img.style.opacity = "1";
        }
        setLoading(wrap, false);
        resolve(Boolean(ok));
      }

      function tryNext() {
        if (loadTokenByImg.get(img) !== token) {
          resolve(false);
          return;
        }
        if (index >= candidates.length) {
          finish(false);
          return;
        }
        var src = candidates[index++];
        var loader = new Image();
        loader.onload = function () {
          finish(true, loader.src);
        };
        loader.onerror = tryNext;
        loader.src = src;
      }

      tryNext();
    });
  }

  function llSetMediaLoading(imgOrSelector, isLoading) {
    var img =
      typeof imgOrSelector === "string"
        ? document.querySelector(imgOrSelector)
        : imgOrSelector;
    setLoading(resolveWrap(img), isLoading);
  }

  global.llLoadProductImage = llLoadProductImage;
  global.llSetMediaLoading = llSetMediaLoading;
})(window);
